import React, { useMemo } from 'react';
import { Text } from '@moda/om';
import { SECONDS_TO_MILLISECONDS, useTimer } from '@moda/portal-stanchions';
import { LineItem } from '../../../hooks/useCart/cart.rest';

type Props = {
  item: LineItem;
};

export const SavedLineItemSoldOut: React.FC<Props> = ({
  item: {
    attributes: { inventory, skuId, isSoldOut, activeEndAt },
    type
  }
}) => {
  const isSizeSoldOut = useMemo(
    () => inventory.find(item => item.id === skuId)?.available === 0,
    [inventory, skuId]
  );

  const [timeLeft] = useTimer((activeEndAt || Infinity) * SECONDS_TO_MILLISECONDS);

  if (type === 'cart_items') return null;

  return (
    <>
      {isSizeSoldOut && !isSoldOut && (
        <Text treatment="body2" color="cement">
          Size Sold Out
        </Text>
      )}
      {isSoldOut && (
        <Text treatment="body2" color="cement">
          Sold Out
        </Text>
      )}
      {timeLeft.isOver && (
        <Text treatment="body2" color="cement">
          Trunkshow has ended
        </Text>
      )}
    </>
  );
};
